import { apiUrls } from "../consts/ApiUrls";

import { portalApiClient } from "./apiClient";
import { InspectionResponse } from "src/types/InspectionUpdateRequest";

export default async function getProjectvariations(companyId) {
  const url = apiUrls.getDeviations.url(companyId);
  try {
    const data = await portalApiClient.get(url);

    return data.data as InspectionResponse[];
  } catch (err) {
    throw err;
  }
}

export async function getProjectvariationById(companyId, variationId) {
  const url = apiUrls.getProjectVariationById.url(companyId, variationId);
  if (companyId && variationId) {
    const data = await portalApiClient.get(url);
    return data.data as InspectionResponse;
  }
}

export async function createVariation(payload) {
  return await portalApiClient.post(
    apiUrls.createProjectVariation.url(),
    JSON.stringify(payload),
    {}
  );
}
